import { render, staticRenderFns } from "./UserRoleList.vue?vue&type=template&id=5fdf13d1&"
import script from "./UserRoleList.vue?vue&type=script&lang=ts&"
export * from "./UserRoleList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports